"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplyEffects_OnEventEventHandlerScript = void 0;
const Registries_1 = require("../../core/state/Registries");
let ApplyEffects_OnEventEventHandlerScript = class ApplyEffects_OnEventEventHandlerScript {
    run(sequence, container, handler, event) {
        const targets = container.selectLivingTargets(event.subject, handler.args.scriptArgs.target);
        handler.args.scriptArgs.effects.forEach(({ effect, duration, supernatural = false }) => {
            targets.forEach(targetId => {
                if (effect.harmful) {
                    container.applyDebuff({
                        sequence,
                        attackerId: event.subject,
                        targetId,
                        duration,
                        effect,
                        supernatural
                    });
                }
                else {
                    container.applyBuff({
                        sequence,
                        creatorId: event.subject,
                        targetId,
                        duration,
                        effect,
                        supernatural
                    });
                }
            });
        });
    }
};
ApplyEffects_OnEventEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("ApplyEffects_OnEvent")
], ApplyEffects_OnEventEventHandlerScript);
exports.ApplyEffects_OnEventEventHandlerScript = ApplyEffects_OnEventEventHandlerScript;
